import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import dataLayout from '../views/layout/dataLayout'
import ArticleLayout from '../views/layout/ArticleLayout'
import dataCenter from '../views/datacenter/index'
import AiCenter from '../views/aicenter/index'
import KidAreaSet from '../views/datacenter/components/eeopset/areaset/index'
import SysSet from '../views/datacenter/components/eeopset/sysset/index'
import { KidIngredient,IngredientEdit,ApplyInfo,KidDishes,DishesEdit,DishesApply,BasisYears,BasisDirs,AssessRule } from '../views/datacenter/components/basedata/index.js'
import { ActionDock,DictTypeList,DictList,FoodMenu, Balance } from '../views/aicenter/components/index'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/articlePreview', component: () => import('@/views/article/article_preview'), hidden: true},
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/customer',
    name: 'pms',
    meta: {title: '客户', icon: 'pms'},
    children: [
      {
        path: 'customer',
        name: 'customer',
        component: () => import('@/views/pms/index'),
        meta: {title: '客户', icon: 'pms'}
      },
      {
        path: 'customer/detail',
        name: 'detail',
        component: () => import('@/views/pms/detail'),
        meta: {title: '客户详情'},
        hidden: true
      },
      {
        path: 'customer/order',
        name: 'customerorderdetail',
        component: () => import('@/views/oms/detail'),
        meta: {title: '订单详情'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'oms'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/index'),
        meta: {title: '订单', icon: 'oms'}
      },
      {
        path: 'order/detail',
        name: 'orderdetail',
        component: () => import('@/views/oms/detail'),
        meta: {title: '订单详情'},
        hidden: true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/list',
    name: 'sms',
    meta: {title: '版本', icon: 'sms'},
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/sms/index'),
        meta: {title: '版本', icon: 'sms'}
      }
    ]
  },
  {
    path:'/yyjc',
    component: Layout,
    redirect: '/yyjc/monitor',
    name: 'yyjc',
    meta: {title: '运营监测', icon: 'yyjc'},
    children: [
      {
        path: 'monitor',
        name: 'monitor',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '运营监测', icon: 'yyjc'}
      }
    ]
  },
  {
    path:'/datacenter',
    component: dataLayout,
    redirect: '/datacenter/dclist',
    name: 'datacenter',
    meta: {title: '数据中心', icon: 'datacenter'},
    children: [
      {
        path: 'dclist',
        name: 'dclist',
        component: dataCenter,
        redirect: '/datacenter/dclist/datalist',
        meta: {title: '数据中心', icon: 'datacenter',tab: 'food'},
        children: [
          {
            path: 'datalist',
            name: 'datalist',
            meta: {title: '数据中心', icon: 'datacenter',tab:'food'},
            components:{
              ingredient: KidIngredient
            },
            hidden: true
          }
        ]
      },
      {
        path:'ingredientedit',
        component: dataCenter,
        meta: {title: '数据中心', icon: 'datacenter'},
        redirect: '/datacenter/ingredientedit/dataingredientedit',
        name: 'ingredientedit',
        children:[
          {
            path: 'dataingredientedit',
            name: 'dataingredientedit',
            meta: {tab: 'food'},
            components: {
              ingredient: IngredientEdit
            },
            hidden: true
          }
        ],
        hidden: true
      },
      {
        path:'ingredientapplyinfo',
        component: dataCenter,
        redirect: '/datacenter/ingredientapplyinfo/dataingredientapply',
        name: 'ingredientapplyinfo',
        children:[
          {
            path: 'dataingredientapply',
            name: 'dataingredientapply',
            meta: {tab: 'food'},
            components: {
              ingredient: ApplyInfo
            },
            hidden: true
          }
        ],
        hidden: true
      },
      {
        path:'dishes',
        component: dataCenter,
        redirect: '/datacenter/dishes/dishesList',
        name: 'dishes',
        children:[
          {
            path: 'dishesList',
            name: 'dishesList',
            meta: {tab: 'dishes'},
            components: {
              dishes: KidDishes
            },
            hidden: true
          },
          {
            path: 'dishes_info',
            name: 'dishes_info',
            meta: {tab: 'dishes'},
            components: {
              dishes: DishesEdit
            },
            hidden: true
          },
          {
            path: 'dishes_apply_info',
            name: 'dishes_apply_info',
            meta: {tab: 'dishes'},
            components: {
              dishes: DishesApply
            },
            hidden: true
          }
        ],
        hidden: true
      },
      {
        path: 'basis',
        name: 'basis',
        component: dataCenter,
        children: [
          {
            path: 'dirsyearlist',
            name: 'dirsyearlist',
            meta: {title: '营养标准', icon: 'datacenter',tab:'basis'},
            components:{
              basis: BasisYears
            },
            hidden: true
          },
          {
            path: 'dirslist',
            name: 'dirslist',
            meta: {title: '营养标准', icon: 'datacenter',tab:'basis'},
            components:{
              basis: BasisDirs
            },
            hidden: true
          },
          {
            path: 'assess',
            name: 'assess',
            meta: {title: '营养标准', icon: 'datacenter',tab:'basis'},
            components:{
              basis: AssessRule
            },
            hidden: true
          }
        ]
      },
      {
        path:'areaset',
        component: dataCenter,
        redirect: '/datacenter/areaset/areaList',
        name: 'areaset',
        children:[
          {
            path: 'areaList',
            name: 'areaList',
            meta: {tab: 'area'},
            components: {
              area: KidAreaSet
            },
            hidden: true
          }
        ],
        hidden: true
      },
      {
        path:'sysset',
        component: dataCenter,
        redirect: '/datacenter/sysset/sysm',
        name: 'sysset',
        children:[
          {
            path: 'sysm',
            name: 'sysm',
            meta: {tab: 'sysset'},
            components: {
              sysset: SysSet
            },
            hidden: true
          }
        ],
        hidden: true
      }
    ]
  },
  {
    path:'/aicenter',
    component: dataLayout,
    redirect: '/aicenter/actiondock',
    name: 'aicenter',
    meta: {title: 'AI中心', icon: 'aicenter'},
    children: [
      {
        path: 'actiondock',
        name: 'actiondock',
        component: AiCenter,
        redirect: '/aicenter/actiondock/action',
        meta: {title: 'AI中心', icon: 'aicenter'},
        children: [
          {
            path: 'action',
            name: 'action',
            meta: {tab: 'actionDock'},
            components:{
              actionDock: ActionDock
            },
            hidden: true
          }
        ]
      },
      {
        path:'foodMenu',
        component: AiCenter,
        redirect: '/aicenter/foodMenu/menuset',
        name: 'foodMenu',
        children:[
          {
            path: 'menuset',
            name: 'menuset',
            meta: {tab: 'foodMenu'},
            components: {
              foodMenu: FoodMenu
            },
            hidden: true
          }
        ],
        hidden: true
      },
      {
        path:'balance',
        component: AiCenter,
        redirect: '/aicenter/balance/adjust',
        name: 'balance',
        children:[
          {
            path: 'adjust',
            name: 'adjust',
            meta: {tab: 'balance'},
            components: {
              balance: Balance
            },
            hidden: true
          }
        ],
        hidden: true
      },
      {
        path:'dicttype',
        component: AiCenter,
        redirect: '/aicenter/dicttype/typelist',
        name: 'dicttype',
        children:[
          {
            path: 'typelist',
            name: 'typelist',
            meta: {tab: 'dicType'},
            components: {
              dicType: DictTypeList
            },
            hidden: true
          }
        ],
        hidden: true
      },
      {
        path:'dicm',
        component: AiCenter,
        redirect: '/aicenter/dicm/dictlist',
        name: 'dicm',
        children:[
          {
            path: 'dictlist',
            name: 'dictlist',
            meta: {tab: 'dicm'},
            components: {
              dicm: DictList
            },
            hidden: true
          }
        ],
        hidden: true
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '用户', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/notice',
    component: Layout,
    redirect: '/notice/noticelist',
    name: 'notice',
    meta: {title: '通知', icon: 'notice'},
    children: [
      {
        path: 'noticelist',
        name: 'noticelist',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '通知', icon: 'notice'}
      }
    ]
  },
  {
    path:'/atricle',
    component: ArticleLayout,
    redirect: '/atricle/articlelist',
    name: 'article',
    meta: {title: '文章', icon: 'article'},
    children: [
      {
        path: 'articlelist',
        name: 'articlelist',
        component: () => import('@/views/article/index'),
        meta: {title: '文章', icon: 'article'}
      },
      {
        path: 'articleEdit',
        name: 'articleEdit',
        component: () => import('@/views/article/edit'),
        meta: {title: '文章', icon: 'article'}
      },
      {
        path: 'adviseList',
        name: 'adviseList',
        component: () => import('@/views/article/adviseList'),
        meta: {title: '文章', icon: 'article'}
      },
      {
        path: 'adviseEdit',
        name: 'adviseEdit',
        component: () => import('@/views/article/adviseEdit'),
        meta: {title: '文章', icon: 'article'}
      }
    ]
  },
  {
    path:'/health',
    component: ArticleLayout,
    redirect: '/health/health_list',
    name: 'health',
    meta: {title: '健康评估', icon: 'health'},
    children: [
      {
        path: 'health_list',
        name: 'health_list',
        component: () => import('@/views/health/index'),
        meta: {title: '健康评估', icon: 'health'}
      },
      {
        path: 'idcard_list',
        name: 'idcard_list',
        component: () => import('@/views/health/idcard/index'),
        meta: {title: '身份卡', icon: 'health'}
      },
      {
        path: 'question_list',
        name: 'question_list',
        component: () => import('@/views/health/questionBank/index'),
        meta: {title: '题库', icon: 'health'}
      },
      {
        path: 'template_list',
        name: 'template_list',
        component: () => import('@/views/health/templates/index'),
        meta: {title: '编辑模板信息', icon: 'health'}
      }
    ]
  },
  {
    path:'/setting',
    component: Layout,
    redirect: '/setting/info',
    name: 'setting',
    meta: {title: '设置', icon: 'setting'},
    children: [
      {
        path: 'info',
        name: 'info',
        component: () => import('@/views/setting/index'),
        meta: {title: '设置', icon: 'setting'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js